(function($){

    "use strict";

    $(document).ready(function() {

        $(document).on('click', '.cart_search_block .search-icon-header .close-black-block', function(event) {

            event.preventDefault();

            $('.cart_search_block .search-icon-header').removeClass('open');
            $(".cart_search_block .search-icon-header .focus-input").focus();

        });

        $(document).on('click', '.cart_search_block .search-icon-header > a', function(event) {

            event.preventDefault();

            $('.cart_search_block .search-icon-header').addClass('open');
            $(".cart_search_block .search-icon-header .focus-input").focus();

        });

        $('.cart_search_block #searchsubmit').click(function(e){

            var search_text = $('.cart_search_block input[name="s"]').val();
    
            if( search_text.length >= 3 ){

                return true;

            }else{

                e.preventDefault();

            }
                
        });

        $('.cart_search_block input[value="s"]').keydown(function(e){

            var search_text = $(this).val();
    
            if( e.keyCode == 13 && ( search_text.length >= 3 ) ){
                
                return true;

            }else{

                e.preventDefault();

            }
                
        });

    });

})(jQuery);